import React, { useContext } from "react";
import PropTypes from "prop-types";

import SelectVehicleMakeFilter from "../../../components/InputComponents/SelectVehicleMakeFilter/SelectVehicleMakeFilter";
import SelectVehicleModelFilter from "../InputComponents/SelectVehicleModelFilter/SelectVehicleModelFilter";
import SelectVehicleTrimFilter from "../InputComponents/SelectVehicleTrimFilter/SelectVehicleTrimFilter";

import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import { FormattedMessage } from "react-intl";

const IncentiveVehicleOptions = ({ electricVehicles }) => {
  const userPrefs = useContext(UserPrefsContext);
  const makeOption = userPrefs.get("vehicleMakeFilter");
  const modelOption = userPrefs.get("vehicleModelFilter");

  return (
    <div className="input-well MatchScoreOptions">
      <p className="h2">
        <FormattedMessage
          id="evs.electricVehicleFilters"
          defaultMessage="Electric Vehicle Filters"
          description="Electric Vehicle Filters"
        />
      </p>
      <SelectVehicleMakeFilter vehicles={electricVehicles} />
      <SelectVehicleModelFilter
        vehicles={electricVehicles}
        makeOption={makeOption}
      />
      <SelectVehicleTrimFilter
        vehicles={electricVehicles}
        makeOption={makeOption}
        modelOption={modelOption}
      />
    </div>
  );
};

export default IncentiveVehicleOptions;

IncentiveVehicleOptions.propTypes = {
  electricVehicles: PropTypes.array,
};
